"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeField = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const date_fns_1 = __importDefault(require("@date-io/date-fns"));
const date_fns_2 = require("date-fns");
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
const Clear_1 = __importDefault(require("@material-ui/icons/Clear"));
const InsertInvitation_1 = __importDefault(require("@material-ui/icons/InsertInvitation"));
const MuiPickersUtilsProvider_1 = __importDefault(require("@material-ui/pickers/MuiPickersUtilsProvider"));
const TimePicker_1 = require("@material-ui/pickers/TimePicker");
const locale_context_1 = require("../../providers/locale/locale-context");
const auto_focus_hook_1 = require("../../utils/auto-focus-hook");
const date_utils_1 = require("../../utils/date-utils");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const time_field_styles_1 = require("./time-field-styles");
function TimeField({ form, disabled, minTime: minTimeString, maxTime: maxTimeString, value, onChange, showSeconds = true, autoFocus, }) {
    // fix undefined value
    value = value !== null && value !== void 0 ? value : null;
    const [open, setOpen] = (0, react_1.useState)(false);
    const handleOpen = (0, event_callback_hook_1.useEventCallback)(() => {
        setOpen(true);
    });
    const handleClose = (0, event_callback_hook_1.useEventCallback)(() => {
        setOpen(false);
    });
    const intl = (0, react_intl_1.useIntl)();
    const { locale } = (0, react_1.useContext)(locale_context_1.LocaleContext);
    const [internalValue, setInternalValue] = (0, react_1.useState)(() => (0, date_utils_1.parseISOTimeSafe)(value));
    const { autoFocusRef } = (0, auto_focus_hook_1.useAutoFocus)(autoFocus, disabled);
    const minTime = (0, date_utils_1.parseISOTimeSafe)(minTimeString);
    const maxTime = (0, date_utils_1.parseISOTimeSafe)(maxTimeString);
    const showClearButton = !disabled && value !== null;
    const showPickerButton = !disabled;
    const isError = (0, event_callback_hook_1.useEventCallback)((date) => {
        if (date != null) {
            if (!(0, date_fns_2.isValid)(date)) {
                return true;
            }
            else if (maxTime && date > maxTime) {
                return true;
            }
            else if (minTime && date < minTime) {
                return true;
            }
        }
        return false;
    });
    // update internal representation if supplied from above
    (0, react_1.useEffect)(() => setInternalValue((0, date_utils_1.parseISOTimeSafe)(value)), [value]);
    // stores the new value in internal storage and propagates above only null and valid dates
    const handleChange = (0, event_callback_hook_1.useEventCallback)((date) => {
        setInternalValue(date);
        if (date == null) {
            onChange(null);
        }
        else if (!isError(date)) {
            onChange((0, date_utils_1.formatISOTime)(date, showSeconds));
            // console.log('time', formatISOTime(date));
        }
    });
    const classes = (0, time_field_styles_1.useStyles)();
    const handleClear = (0, event_callback_hook_1.useEventCallback)((e) => {
        e.stopPropagation();
        handleChange(null);
    });
    return (react_1.default.createElement(MuiPickersUtilsProvider_1.default, { utils: date_fns_1.default, locale: locale.dateFnsLocale },
        react_1.default.createElement(TimePicker_1.KeyboardTimePicker, { inputProps: {
                form,
            }, inputRef: autoFocusRef, autoOk: true, ampm: false, variant: "dialog", fullWidth: true, disabled: disabled, value: internalValue, format: showSeconds ? locale.timeFormat : locale.shortTimeFormat, onChange: handleChange, open: open, onOpen: handleOpen, onClose: handleClose, InputProps: {
                classes: {
                    root: classes.root,
                    input: classes.input,
                },
                endAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "end" },
                    showClearButton && (react_1.default.createElement(IconButton_1.default, { size: "small", onClick: handleClear, className: classes.icon },
                        react_1.default.createElement(Clear_1.default, { fontSize: "small" }))),
                    showPickerButton && (react_1.default.createElement(IconButton_1.default, { size: "small", onClick: handleOpen, className: classes.icon },
                        react_1.default.createElement(InsertInvitation_1.default, { fontSize: "small" }))))),
            }, InputAdornmentProps: {
                position: 'start',
                style: { display: 'none' },
            }, cancelLabel: intl.formatMessage({
                id: 'EAS_DATEPICKER_BUTTON_CANCEL',
                defaultMessage: 'Zrušit',
            }), okLabel: intl.formatMessage({
                id: 'EAS_DATEPICKER_BUTTON_OK',
                defaultMessage: 'Potvrdit',
            }), 
            // don't show error messages only error underline
            invalidDateMessage: "", maxDateMessage: "", minDateMessage: "", error: disabled ? false : isError(internalValue), views: showSeconds ? ['hours', 'minutes', 'seconds'] : ['hours', 'minutes'] })));
}
exports.TimeField = TimeField;
//# sourceMappingURL=time-field.js.map